import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'nominas/historico-comentarios-empleados';

/**
 * GET Historicos Comentarios de Empleado
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getHistoricosComentariosDeEmpleados = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Historico Comentario de Empleado
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getHistoricoComentarioDeEmpleado = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Historicos Comentarios de Empleado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postHistoricoComentarioDeEmpleado = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};
